<template>
  <div>
    <v-btn
      @click="InitiatePaymentRequest()"
      elevation="6"
      large
      block
      class="ml-n3 ma-1 appbutton rounded-lg white--text font-weight-medium"
      color="#B22AF0"
      z-index="12"
    >
      Verify & Accept</v-btn
    >
  </div>
</template>

<script>
// import { CREATE_PAYMENT_AUTH_REQ } from "../mutations";
import * as _ from 'lodash';
const { GraphQLClient } = require('graphql-request');
import {
  getFirestore,
  connectFirestoreEmulator,
  doc,
  collection,
  updateDoc,
  getDoc,
  setDoc,
} from 'firebase/firestore';

import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from 'firebase/functions';
import * as dotenv from 'dotenv';

export default {
  name: 'LinkPay',
  props: ['booking'],

  data: () => ({
    clientToken: '',
    client_id: '',
    code_challenge: '',
    redirect_uri: '',
    nonce: '',
    state: '',
    scope: [],
  }),

  components: {
    // stitch: () => import('./Stitch.vue'),
  },
  mounted() {},

  methods: {
    async InitiatePaymentRequest() {
      this.$store.commit('setLoading', true);
      const functions = getFunctions();

      // connectFunctionsEmulator(functions, 'localhost', 5001);

      const db = getFirestore();
      const userRef = doc(db, 'users', this.$store.state.user.id);
      const userSnap = await getDoc(userRef);
      console.log('userSnap', userSnap.data());

      const user = userSnap.data();

      this.user = user;

      const createVerificationLinkingUrl = httpsCallable(
        functions,
        'createVerificationLinkingUrl'
      );

      createVerificationLinkingUrl({
        email: this.$store.state.user.email,
        firstName: this.user.firstName,
        phoneNumber: this.$store.state.user.phoneNumber,
        userId: this.user.id,
        bookingId: this.booking.id,
        booking: this.booking,
      }).then((result) => {
        // Read result of the Cloud Function.
        /** @type {any} */
        const data = result.data;
        console.log('data', data);

        if (!data.error) {
          window.location.replace(data, '_self');
        }
        // if data comes back as error object then redirect to error page
        if (data.error) {
          console.log('error');
          this.errorMessage = 'Error: Could not create new linking URL';
          this.$emit('erorr', this.errorMessage);
          this.error = true;
          this.$store.commit('setError', this.errorMessage);
          this.$store.commit('setLoading', false);
        }

        if (
          data.error.response.errors[0].extensions.code ==
          'INTERNAL_SERVER_ERROR'
        ) {
          this.errorMessage = 'STITCH INTERNAL SERVER ERROR';
          this.$emit('erorr', this.errorMessage);
          this.error = true;
          this.$store.commit('setError', this.errorMessage);
          this.$store.commit('setLoading', false);
        }

        if (data === null || !data) {
          this.errorMessage = 'Error: Could not create new linking URL';
          this.$emit('erorr', this.errorMessage);
          this.error = true;
          this.$store.commit('setError', this.errorMessage);
          this.$store.commit('setLoading', false);
        }
      });

      //   //set loading state in store to true
      //   this.$store.commit('setLoading', true);
      //   //save the booking.id tp the vuex store
      //   await this.$store.dispatch('setBooking', this.booking);
      //   //begin loading animation
      //   this.loading = true;
      //   // const clientId = 'test-aa1f562a-291b-4cb7-8fda-990a46024b51';
      //   const clientId = '4fcd9ca1-e007-4420-9c00-a57f0200bc65';
      //   // const clientSecret =
      //   //   'z2KdbCu4g4rcL9mZ4dj3nGyqi9zQ+Bup5eMjYxWhYWwnf3tV4qeGg5PnWUFqsR7cdW2St1G2iNP8dRHAM8IevQ==';

      //   const clientSecret =
      //     'kSLkoypZDnJc5Q3jolzIVZBgr71GV6ESoPSd6qi7ohkKLRQasbTQ0y9phyAz9YtG/lNGSzdIkOZeASbMC+WvlQ==';

      //   const db = getFirestore();
      //   const userDoc = doc(db, 'users', this.$store.state.user.id);
      //   const userDocSnap = await getDoc(userDoc);
      //   const user = userDocSnap.data();
      //   console.log(user);
      //   const scopes = [
      //     'client_paymentauthorizationrequest',
      //     'accounts',
      //     'transactions',
      //     'balances',
      //     'accountholders',
      //   ];
      //   const clientToken = await this.retrieveTokenUsingClientSecret(
      //     clientId,
      //     clientSecret,
      //     scopes
      //   );
      //   console.log('client', clientToken);
      //   const codechallenge = await this.genChallenge();
      //   const verifier = codechallenge[0];
      //   const challenge = codechallenge[1];
      //   console.log('challenge', challenge);
      //   console.log('verifier', verifier);
      //   //Save verifier to store
      //   this.$store.dispatch('setVerifier', verifier);
      //   const nonceState = await this.nonceState();
      //   const nonce = nonceState[0];
      //   const state = nonceState[1];
      //   console.log('nonce', nonce);
      //   console.log('state', state);
      //   // const redirectUri = 'http://localhost:8080/return';
      //   const redirectUri = 'https://strapp-dev.web.app/return';
      //   // a verification object
      //   const verification = {
      //     verifier: verifier,
      //     verificationStatus: 'initiated',
      //     verifiedAt: new Date(),
      //     state: state,
      //   };
      //   await updateDoc(doc(db, 'bookings', this.booking.id), verification);
      //   // const newPayRef = doc(collection(db, "payments", "payment"));
      //   // await setDoc(newPayRef, {
      //   //   verifier: verifier,
      //   //   status: "initiated",
      //   //   createdAt: new Date(),
      //   // });

      //   const graphQLClient = new GraphQLClient(
      //     'https://api.stitch.money/graphql',
      //     {
      //       headers: {
      //         authorization: `Bearer ${clientToken}`,
      //       },
      //     }
      //   );
      //   const newScopes = [
      //     'client_paymentauthorizationrequest',
      //     'accounts',
      //     'transactions',
      //     'balances',
      //     'accountholders',
      //     'offline_access',
      //   ];

      //   var shortbookingId = this.booking.id.substring(0, 12);

      //   const CreatePaymentAuthorizationRequest = `
      //             mutation CreateAccountLinkingRequest (
      //               $accountType: AccountType!,
      //               $beneficiaryType: BankBeneficiaryType!,
      //               $payerReference: String!,
      //               $beneficiaryReference: String!,
      //               $beneficiaryName: String!,
      //               $email: EmailAddress!,
      //               $name: String!,
      //               $phoneNumber: String!,
      //               $beneficiaryBankId: BankBeneficiaryBankId!,
      //               $beneficiaryAccountNumber: String!,
      //               ) {
      //          clientPaymentAuthorizationRequestCreate(input: {
      //         beneficiary: {
      //         bankAccount: {
      //            name: $beneficiaryName,
      //           bankId: $beneficiaryBankId,
      //           accountNumber: $beneficiaryAccountNumber
      //           accountType: $accountType,
      //           beneficiaryType: $beneficiaryType,
      //           reference: $beneficiaryReference
      //         }
      //       },  payer: {
      //   email:   $email
      //   name: $name,
      //   reference: $payerReference,
      //   phoneNumber:  $phoneNumber
      // }
      //     })
      //    {
      //    authorizationRequestUrl
      //     }
      //      }`;
      //   graphQLClient
      //     .request(CreatePaymentAuthorizationRequest, {
      //       accountType: 'current',
      //       beneficiaryType: 'private',
      //       payerReference: 'strapp-pay',
      //       beneficiaryReference: shortbookingId,
      //       externalReference: 'strapp-pay',
      //       beneficiaryName: 'Strapp',
      //       beneficiaryBankId: 'fnb',
      //       beneficiaryAccountNumber: '63042720341',
      //       email: this.$store.state.user.email,
      //       name: this.$store.state.user.firstName,
      //       payerReference: 'Strapp',
      //       phoneNumber: this.$store.state.user.phoneNumber,
      //     })
      //     .then((data) => {
      //       const baseurl =
      //         data.clientPaymentAuthorizationRequestCreate
      //           .authorizationRequestUrl;
      //       console.log(data);
      //       console.log(
      //         'url',
      //         data.clientPaymentAuthorizationRequestCreate.authorizationRequestUrl
      //       );
      //       const search = {
      //         client_id: clientId,
      //         code_challenge: challenge,
      //         code_challenge_method: 'S256',
      //         redirect_uri: redirectUri,
      //         scope: newScopes.join(' '),
      //         response_type: 'code',
      //         nonce: nonce,
      //         state: state,
      //       };
      //       const searchString = Object.entries(search)
      //         .map(([j, v]) => `${j}=${encodeURIComponent(v)}`)
      //         .join('&');
      //       const paymentUrl = `${baseurl}?${searchString}`;
      //       console.log('paymentUrl:', paymentUrl);
      //       console.log(paymentUrl);
      //       // window.location.replace(paymentUrl, '_self');
      //     })
      //     .catch((error) => {
      //       console.log(error);
      //       //emit error to parent
      //       this.$emit('error', error);
      //       this.$store.commit('setLoading', false);
      //     })
      //     .finally(() => {
      //       this.loading = false;
      //     });
      // },
      // async nonceState() {
      //   function base64UrlEncode(byteArray) {
      //     const charCodes = String.fromCharCode(...byteArray);
      //     return window
      //       .btoa(charCodes)
      //       .replace(/\+/g, '-')
      //       .replace(/\//g, '_')
      //       .replace(/=/g, '');
      //   }
      //   function generateRandomStateOrNonce() {
      //     const randomBytes = crypto.getRandomValues(new Uint8Array(32));
      //     return base64UrlEncode(randomBytes);
      //   }
      //   const state = generateRandomStateOrNonce();
      //   // console.log("State:", state);
      //   const nonce = generateRandomStateOrNonce();
      //   // console.log("Nonce:", nonce);
      //   return [nonce, state];
      // },
      // async retrieveTokenUsingClientSecret(clientId, client_secret, scopes) {
      //   const body = {
      //     grant_type: 'client_credentials',
      //     client_id: clientId,
      //     scope: scopes.join(' '),
      //     audience: 'https://secure.stitch.money/connect/token',
      //     client_secret: client_secret,
      //   };
      //   const bodyString = Object.entries(body)
      //     .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
      //     .join('&');
      //   const response = await fetch(
      //     'https://secure.stitch.money/connect/token',
      //     {
      //       method: 'post',
      //       headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      //       body: bodyString,
      //     }
      //   );
      //   const responseBody = await response.json();
      //   console.log('Tokens: ', responseBody);
      //   return responseBody.access_token;
      // },
      // async genChallenge() {
      //   function base64UrlEncode(byteArray) {
      //     const charCodes = String.fromCharCode(...byteArray);
      //     return window
      //       .btoa(charCodes)
      //       .replace(/\+/g, '-')
      //       .replace(/\//g, '_')
      //       .replace(/=/g, '');
      //   }
      //   async function sha256(verifier) {
      //     const msgBuffer = new TextEncoder('utf-8').encode(verifier);
      //     // hash the message
      //     const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
      //     return new Uint8Array(hashBuffer);
      //   }
      //   const randomBytes = crypto.getRandomValues(new Uint8Array(32));
      //   const verifier = base64UrlEncode(randomBytes);
      //   // console.log("Verifier:", verifier);
      //   const challenge = await sha256(verifier).then(base64UrlEncode);
      //   // console.log("Challenge:", challenge);
      //   return [verifier, challenge];
    },
  },
};
</script>

<style>
.grid {
  place-items: center;
  display: grid;
}
</style>
